// import React from "react";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";

// const Home = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="bg-white">

//       {/* ================= HEADER HERO ================= */}
//       <div
//         className="relative overflow-hidden rounded-b-[50px] shadow-2xl
//       bg-gradient-to-br from-[#0c1b29] via-[#102531] to-[#0c1b29]
//       py-36 px-6 md:px-20 mb-20 text-white"
//       >
//         {/* Glossy Shine Layer */}
//         <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(255,255,255,0.15),transparent_40%)] pointer-events-none" />

//         {/* Soft Glow */}
//         <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[500px] h-[500px]
//         bg-[#87c3bc]/9 blur-[120px] rounded-full"></div>

//         {/* Subtle side tint */}
//         <div className="absolute bottom-0 right-0 w-[300px] h-[300px]
//         bg-[#87c3bc]/6 blur-[100px] rounded-full"></div>

//         <motion.h1
//           initial={{ opacity: 0, y: 40 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.9 }}
//           className="relative text-5xl md:text-7xl font-extrabold leading-tight drop-shadow-lg"
//         >
//           Welcome to <span className="text-[#87c3bc] font-bold">ISIN</span>
//         </motion.h1>

//         <motion.p
//           initial={{ opacity: 0, y: 40 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.3, duration: 0.9 }}
//           className="relative max-w-2xl mt-8 text-lg md:text-xl text-white/85 leading-relaxed"
//         >
//           Delivering innovative, reliable, and scalable IT solutions built with precision
//           and aligned with your business needs.
//         </motion.p>

//         {/* Glossy Button */}
//         <motion.div
//           initial={{ opacity: 0, y: 40 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.6, duration: 0.9 }}
//           className="relative mt-12"
//         >
//           <button
//             onClick={() => navigate("/services")}
//             className="px-10 py-4 text-lg font-semibold rounded-full transition-all duration-300
//             bg-[#87c3bc] text-black shadow-lg hover:shadow-2xl hover:brightness-110
//             relative overflow-hidden"
//           >
//             <span className="relative z-10">Explore Our Services</span>

//             {/* Gloss reflection */}
//             <span className="absolute inset-0 bg-[linear-gradient(135deg,rgba(255,255,255,0.4),rgba(255,255,255,0)_40%)] opacity-40"></span>
//           </button>
//         </motion.div>
//       </div>

//     </div>
//   );
// };

// export default Home;
import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Wrench } from "lucide-react"; // Icon
import Header from "./Header";
import Footer from "./Footer";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white">
      <Header />

      {/* ================= HEADER HERO ================= */}
      <div
        className="relative overflow-hidden rounded-b-[50px] shadow-2xl
      bg-gradient-to-br from-[#0c1b29] via-[#102531] to-[#0c1b29]
      py-36 px-6 md:px-20 mb-20 text-white"
      >
        {/* Glossy Shine Layer */}
        <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(255,255,255,0.15),transparent_40%)] pointer-events-none" />

        {/* Soft Glow */}
        <div
          className="absolute -top-32 left-1/2 -translate-x-1/2 w-[500px] h-[500px]
        bg-[#87c3bc]/9 blur-[120px] rounded-full"
        ></div>

        {/* Subtle side tint */}
        <div
          className="absolute bottom-0 right-0 w-[300px] h-[300px]
        bg-[#87c3bc]/6 blur-[100px] rounded-full"
        ></div>

        {/* Icon */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="flex justify-center mb-6"
        >
          <Wrench size={80} className="text-[#87c3bc]" />
        </motion.div>

        {/* Title */}
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          className="relative text-4xl md:text-6xl font-extrabold leading-tight text-center drop-shadow-lg"
        >
          Website <span className="text-[#87c3bc]">Under Construction</span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.9 }}
          className="relative max-w-2xl mt-8 mx-auto text-lg md:text-xl text-white/85 leading-relaxed text-center"
        >
          We’re currently working on building a seamless and professional
          digital experience. Please check back soon — exciting updates are on
          the way!
        </motion.p>

        {/* Temporary Contact Button */}
        <div className="mt-12 text-center">
          <motion.a
            href="mailto:info@isin-eg.com"
            whileHover={{ backgroundColor: "#87c3bc", color: "#0c1b29" }}
            className="inline-flex items-center px-12 py-4
            rounded-full border-2 border-[#87c3bc]
            text-[#87c3bc] font-semibold text-lg
            transition-all duration-300">
            Contact Us
          </motion.a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
